export const formInjectionKey = Symbol('form');

const emailRegex = /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
const phoneRegex = /^[0-9+\s]+$/;
const phoneInternationalRegex = /^\+[0-9\s]+$/;
const phoneIntlRegex = /^\+[0-9]+$/;
const numberRegex = /^[0-9]*$/;
const positiveFracNumberRegex = /^(0|[1-9]\d*)((\.|,)\d+)?$/;
const way4AllowedCharsRegex = /[^a-zA-ZåäöéüøæÅÄÖÉÜØÆ0-9-/. ’,&]/g;
const GFNAllowedCharsRegex = /[^a-zA-ZåäöéüøæÅÄÖÉÜØÆ0-9-/. ’',&]/g;

export const validators = {
    notEmpty(value) {
        if (!value) return 'dsform.empty';
    },
    email(value) {
        if (!emailRegex.test(value) || value.includes(' ')) return 'dsform.email';
    },
    phone(value) {
        if (!phoneRegex.test(value)) return 'dsform.phone';
    },
    phoneIntl(value) {
        if (!phoneIntlRegex.test(value)) return 'dsform.phoneInternational';
    },
    phoneInternational(value) {
        if (!phoneInternationalRegex.test(value)) return 'dsform.phoneInternational';
    },
    number(value) {
        if (!numberRegex.test(value)) return 'dsform.number';
    },
    positiveFracNumber(value) {
        if (!positiveFracNumberRegex.test(value)) return 'dsform.number';
    },
    maxDecimals(value, rule) {
        const [ , digitsAfterDecimal] = value.toString().replace(',', '.').split('.');

        if (digitsAfterDecimal?.length > rule.value) return 'dsform.maxDecimals';
    },
    minLength(value, rule) {
        if (String(value).length < Number(rule.value)) return 'dsform.minLength';
    },
    maxLength(value, rule) {
        if (String(value).length > Number(rule.value)) return 'dsform.maxLength';
    },
    way4AllowedChars(value) {
        if (value.replace(way4AllowedCharsRegex, '').length !== value.length) {
            return 'dsform.containsForbiddenSymbols';
        }
    },
    GFNAllowedChars(value) {
        if (value.replace(GFNAllowedCharsRegex, '').length !== value.length) {
            return 'dsform.containsForbiddenSymbols';
        }
    },
    equals(value, rule) {
        if (value !== rule.value) return 'dsform.equals';
    },
    matches(value, rule, { fieldName, fieldState, state, forceErrors }) {
        const checkMatch = forceErrors || (fieldState[fieldName].hasBeenValid && fieldState[rule.value].hasBeenValid);
        if (checkMatch && value !== state[rule.value]) return 'dsform.matches';
    },
    checkedAmount(value, rule) {
        if (value.length !== Number(rule.value)) return 'dsform.checkedAmount';
    },
    minValue(value, rule) {
        if (Number(value) < rule.value) return rule.message ?? 'dsform.minValue';
    },
    maxValue(value, rule) {
        if (Number(value) > rule.value) return rule.message ?? 'dsform.maxValue';
    },
    roundTo(value, rule) {
        const remainder = Number(value) % Number(rule.value);

        if (remainder !== 0) return 'dsform.roundTo';
    },
    custom(value, rule) {
        if (!rule.method(value)) return rule.message;
    },
};
